/**
 * SuperAdmin sentinel rules — /superadmin/sentinel-rules (route shell).
 *
 * Screen impl in `./sentinel-rules-screen.tsx`, lazy-loaded. Platform-operator-
 * only surface (behind the /superadmin layout gate).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/sentinel-rules')({
  component: lazyRouteComponent(() => import('./sentinel-rules-screen'), 'SentinelRulesPage'),
});
